// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2qwlp","question":"Question_question__2JMEk","description":"Question_description__V5UqA"};